export default function searchDto(view, page, expand) {
  var _view$search$value, _view$search, _view$search$fields$j, _view$search2;
  var frp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Onvio.StaffStorage';
  var orderBy = view.sort ? view.sort.column + ' ' + view.sort.direction : null;
  var search = (_view$search$value = (_view$search = view.search) === null || _view$search === void 0 ? void 0 : _view$search.value) !== null && _view$search$value !== void 0 ? _view$search$value : null;
  var searchBy = (_view$search$fields$j = (_view$search2 = view.search) === null || _view$search2 === void 0 ? void 0 : _view$search2.fields.join(',')) !== null && _view$search$fields$j !== void 0 ? _view$search$fields$j : null;
  var filter = view.filters ? JSON.stringify(filtersToFiltersDto(view.filters)) : null;
  var dto = {
    filterSearchSort: {
      orderBy: orderBy,
      search: search,
      searchBy: searchBy,
      filter: filter
    },
    pagingDataRequest: {
      startIndex: null,
      pageIndex: page.pageNumber,
      itemsPerPage: page.itemCount
    },
    expand: expand !== null && expand !== void 0 ? expand : null,
    frp: frp,
    excludeCount: true
  };
  return dto;
}
export function filtersToFiltersDto(filters) {
  var items = filters.items ? filters.items.map(filterItemToFilterItemDto) : undefined;
  var groups = filters.groups ? filters.groups.map(filtersToFiltersDto) : undefined;
  var dto = {
    useOr: filters.useOr,
    useAnd: filters.useAnd,
    items: items,
    groups: groups
  };
  return dto;
}
export function filterItemToFilterItemDto(item) {
  var dto = {
    by: item.by,
    op: item.op,
    value: item.value,
    values: item.values
  };
  return dto;
}
